import React from "react";

import { SwitchFieldRow } from "../SwitchFieldRow/SwitchFieldRow";

interface CustomisePostSwitchProps {
  platformLabel: string;
  checked: boolean;
  onCheckedChange: () => void;
  "data-testid"?: string;
}

export const CustomisePostSwitch: React.FC<CustomisePostSwitchProps> = ({
  platformLabel,
  checked,
  onCheckedChange,
  "data-testid": testId,
}) => (
  <SwitchFieldRow
    data-testid={testId}
    label={`Customise ${platformLabel} post`}
    checked={checked}
    info={{
      label: `About customising the ${platformLabel} post`,
      content: `Custom changes for ${platformLabel} will apply to all ${platformLabel} accounts that you have selected.`,
    }}
    onCheckedChange={onCheckedChange}
  />
);
